export const environment = {
	production: true,
	clockUrl: "https://clock.timetjek.com",
	apiUrl: "https://api.timetjek.com",
	clockAppUrl: "https://clock2.timetjek.com"
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts